import React from 'react'
import PropTypes from 'prop-types'
import { propTypes } from '../../helpers'
import { Button, Image } from 'react-bootstrap'
import { ContentPanel } from '../container'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

const TenantImage = styled(Image)`
  border-radius: 1.6rem;
  margin: -0.25rem;
  width: 150px;
  height: 150px;
  object-fit: cover;
`

/** a content panel displaying tenant information */
const TenantCard = ({ tenant, imgSrc, imgAlt }) => (
  <ContentPanel className='d-flex'>
    <TenantImage fluid src={imgSrc} alt={imgAlt} />
    <div className='pl-4 flex-grow-1 d-flex flex-column'>
      <h2>{tenant.name}</h2>
      <p>{tenant.description}</p>
      <Button
        as={Link}
        to={`/${tenant.urlSlug}`}
        variant='outline-secondary'
        className='mt-auto align-self-end'
        aria-label={tenant.description || tenant.name}
      >
        Open Portal
      </Button>
    </div>
  </ContentPanel>
)

TenantCard.propTypes = {
  /** the tenant to display */
  tenant: propTypes.tenantPropType,
  /** src for the image displayed in the card */
  imgSrc: PropTypes.string.isRequired,
  /** alt text for the image displayed in the card */
  imgAlt: PropTypes.string.isRequired
}

export { TenantCard }
